/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router';

import { Route as rootRouteImport } from './routes/__root';
import { Route as LayoutAppAppChatsRouteImport } from './routes/_layout-app/app/chats';
import { Route as LayoutAppAppChatsChatIdRouteImport } from './routes/_layout-app/app/chats/$chatId';

const SignOutLazyRouteImport = createFileRoute('/sign-out')();
const AuthLazyRouteImport = createFileRoute('/auth')();
const LayoutAppLazyRouteImport = createFileRoute('/_layout-app')();
const LayoutLazyRouteImport = createFileRoute('/_layout')();
const LayoutIndexLazyRouteImport = createFileRoute('/_layout/')();
const LayoutWelcomeLazyRouteImport = createFileRoute('/_layout/welcome')();
const LayoutTermsLazyRouteImport = createFileRoute('/_layout/terms')();
const LayoutRoadmapLazyRouteImport = createFileRoute('/_layout/roadmap')();
const LayoutPrivacyLazyRouteImport = createFileRoute('/_layout/privacy')();
const LayoutFeaturesLazyRouteImport = createFileRoute('/_layout/features')();
const LayoutContactLazyRouteImport = createFileRoute('/_layout/contact')();
const LayoutAboutLazyRouteImport = createFileRoute('/_layout/about')();
const LayoutAppAppIndexLazyRouteImport = createFileRoute('/_layout-app/app/')();
const LayoutAppAppTransactionsLazyRouteImport = createFileRoute(
  '/_layout-app/app/transactions',
)();
const LayoutAppAppSupportLazyRouteImport = createFileRoute(
  '/_layout-app/app/support',
)();
const LayoutAppAppSettingsLazyRouteImport = createFileRoute(
  '/_layout-app/app/settings',
)();
const LayoutAppAppReceiptsLazyRouteImport = createFileRoute(
  '/_layout-app/app/receipts',
)();
const LayoutAppAppBrandGuideLazyRouteImport = createFileRoute(
  '/_layout-app/app/brand-guide',
)();

const SignOutLazyRoute = SignOutLazyRouteImport.update({
  id: '/sign-out',
  path: '/sign-out',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/sign-out.lazy').then((d) => d.Route));
const AuthLazyRoute = AuthLazyRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/auth.lazy').then((d) => d.Route));
const LayoutAppLazyRoute = LayoutAppLazyRouteImport.update({
  id: '/_layout-app',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/_layout-app.lazy').then((d) => d.Route));
const LayoutLazyRoute = LayoutLazyRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/_layout.lazy').then((d) => d.Route));
const LayoutIndexLazyRoute = LayoutIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutLazyRoute,
} as any).lazy(() =>
  import('./routes/_layout/index.lazy').then((d) => d.Route),
);
const LayoutWelcomeLazyRoute = LayoutWelcomeLazyRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => LayoutLazyRoute,
} as any).lazy(() =>
  import('./routes/_layout/welcome.lazy').then((d) => d.Route),
);
const LayoutTermsLazyRoute = LayoutTermsLazyRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => LayoutLazyRoute,
} as any).lazy(() =>
  import('./routes/_layout/terms.lazy').then((d) => d.Route),
);
const LayoutRoadmapLazyRoute = LayoutRoadmapLazyRouteImport.update({
  id: '/roadmap',
  path: '/roadmap',
  getParentRoute: () => LayoutLazyRoute,
} as any).lazy(() =>
  import('./routes/_layout/roadmap.lazy').then((d) => d.Route),
);
const LayoutPrivacyLazyRoute = LayoutPrivacyLazyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => LayoutLazyRoute,
} as any).lazy(() =>
  import('./routes/_layout/privacy.lazy').then((d) => d.Route),
);
const LayoutFeaturesLazyRoute = LayoutFeaturesLazyRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => LayoutLazyRoute,
} as any).lazy(() =>
  import('./routes/_layout/features.lazy').then((d) => d.Route),
);
const LayoutContactLazyRoute = LayoutContactLazyRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => LayoutLazyRoute,
} as any).lazy(() =>
  import('./routes/_layout/contact.lazy').then((d) => d.Route),
);
const LayoutAboutLazyRoute = LayoutAboutLazyRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => LayoutLazyRoute,
} as any).lazy(() =>
  import('./routes/_layout/about.lazy').then((d) => d.Route),
);
const LayoutAppAppIndexLazyRoute = LayoutAppAppIndexLazyRouteImport.update({
  id: '/app/',
  path: '/app/',
  getParentRoute: () => LayoutAppLazyRoute,
} as any).lazy(() =>
  import('./routes/_layout-app/app/index.lazy').then((d) => d.Route),
);
const LayoutAppAppTransactionsLazyRoute =
  LayoutAppAppTransactionsLazyRouteImport.update({
    id: '/app/transactions',
    path: '/app/transactions',
    getParentRoute: () => LayoutAppLazyRoute,
  } as any).lazy(() =>
    import('./routes/_layout-app/app/transactions.lazy').then((d) => d.Route),
  );
const LayoutAppAppSupportLazyRoute = LayoutAppAppSupportLazyRouteImport.update({
  id: '/app/support',
  path: '/app/support',
  getParentRoute: () => LayoutAppLazyRoute,
} as any).lazy(() =>
  import('./routes/_layout-app/app/support.lazy').then((d) => d.Route),
);
const LayoutAppAppSettingsLazyRoute =
  LayoutAppAppSettingsLazyRouteImport.update({
    id: '/app/settings',
    path: '/app/settings',
    getParentRoute: () => LayoutAppLazyRoute,
  } as any).lazy(() =>
    import('./routes/_layout-app/app/settings.lazy').then((d) => d.Route),
  );
const LayoutAppAppReceiptsLazyRoute =
  LayoutAppAppReceiptsLazyRouteImport.update({
    id: '/app/receipts',
    path: '/app/receipts',
    getParentRoute: () => LayoutAppLazyRoute,
  } as any).lazy(() =>
    import('./routes/_layout-app/app/receipts.lazy').then((d) => d.Route),
  );
const LayoutAppAppBrandGuideLazyRoute =
  LayoutAppAppBrandGuideLazyRouteImport.update({
    id: '/app/brand-guide',
    path: '/app/brand-guide',
    getParentRoute: () => LayoutAppLazyRoute,
  } as any).lazy(() =>
    import('./routes/_layout-app/app/brand-guide.lazy').then((d) => d.Route),
  );
const LayoutAppAppChatsRoute = LayoutAppAppChatsRouteImport.update({
  id: '/app/chats',
  path: '/app/chats',
  getParentRoute: () => LayoutAppLazyRoute,
} as any).lazy(() =>
  import('./routes/_layout-app/app/chats.lazy').then((d) => d.Route),
);
const LayoutAppAppChatsChatIdRoute = LayoutAppAppChatsChatIdRouteImport.update({
  id: '/$chatId',
  path: '/$chatId',
  getParentRoute: () => LayoutAppAppChatsRoute,
} as any).lazy(() =>
  import('./routes/_layout-app/app/chats/$chatId.lazy').then((d) => d.Route),
);

export interface FileRoutesByFullPath {
  '/auth': typeof AuthLazyRoute;
  '/sign-out': typeof SignOutLazyRoute;
  '/about': typeof LayoutAboutLazyRoute;
  '/contact': typeof LayoutContactLazyRoute;
  '/features': typeof LayoutFeaturesLazyRoute;
  '/privacy': typeof LayoutPrivacyLazyRoute;
  '/roadmap': typeof LayoutRoadmapLazyRoute;
  '/terms': typeof LayoutTermsLazyRoute;
  '/welcome': typeof LayoutWelcomeLazyRoute;
  '/': typeof LayoutIndexLazyRoute;
  '/app/chats': typeof LayoutAppAppChatsRouteWithChildren;
  '/app/brand-guide': typeof LayoutAppAppBrandGuideLazyRoute;
  '/app/receipts': typeof LayoutAppAppReceiptsLazyRoute;
  '/app/settings': typeof LayoutAppAppSettingsLazyRoute;
  '/app/support': typeof LayoutAppAppSupportLazyRoute;
  '/app/transactions': typeof LayoutAppAppTransactionsLazyRoute;
  '/app': typeof LayoutAppAppIndexLazyRoute;
  '/app/chats/$chatId': typeof LayoutAppAppChatsChatIdRoute;
}
export interface FileRoutesByTo {
  '/auth': typeof AuthLazyRoute;
  '/sign-out': typeof SignOutLazyRoute;
  '/about': typeof LayoutAboutLazyRoute;
  '/contact': typeof LayoutContactLazyRoute;
  '/features': typeof LayoutFeaturesLazyRoute;
  '/privacy': typeof LayoutPrivacyLazyRoute;
  '/roadmap': typeof LayoutRoadmapLazyRoute;
  '/terms': typeof LayoutTermsLazyRoute;
  '/welcome': typeof LayoutWelcomeLazyRoute;
  '/': typeof LayoutIndexLazyRoute;
  '/app/chats': typeof LayoutAppAppChatsRouteWithChildren;
  '/app/brand-guide': typeof LayoutAppAppBrandGuideLazyRoute;
  '/app/receipts': typeof LayoutAppAppReceiptsLazyRoute;
  '/app/settings': typeof LayoutAppAppSettingsLazyRoute;
  '/app/support': typeof LayoutAppAppSupportLazyRoute;
  '/app/transactions': typeof LayoutAppAppTransactionsLazyRoute;
  '/app': typeof LayoutAppAppIndexLazyRoute;
  '/app/chats/$chatId': typeof LayoutAppAppChatsChatIdRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/_layout': typeof LayoutLazyRouteWithChildren;
  '/_layout-app': typeof LayoutAppLazyRouteWithChildren;
  '/auth': typeof AuthLazyRoute;
  '/sign-out': typeof SignOutLazyRoute;
  '/_layout/about': typeof LayoutAboutLazyRoute;
  '/_layout/contact': typeof LayoutContactLazyRoute;
  '/_layout/features': typeof LayoutFeaturesLazyRoute;
  '/_layout/privacy': typeof LayoutPrivacyLazyRoute;
  '/_layout/roadmap': typeof LayoutRoadmapLazyRoute;
  '/_layout/terms': typeof LayoutTermsLazyRoute;
  '/_layout/welcome': typeof LayoutWelcomeLazyRoute;
  '/_layout/': typeof LayoutIndexLazyRoute;
  '/_layout-app/app/chats': typeof LayoutAppAppChatsRouteWithChildren;
  '/_layout-app/app/brand-guide': typeof LayoutAppAppBrandGuideLazyRoute;
  '/_layout-app/app/receipts': typeof LayoutAppAppReceiptsLazyRoute;
  '/_layout-app/app/settings': typeof LayoutAppAppSettingsLazyRoute;
  '/_layout-app/app/support': typeof LayoutAppAppSupportLazyRoute;
  '/_layout-app/app/transactions': typeof LayoutAppAppTransactionsLazyRoute;
  '/_layout-app/app/': typeof LayoutAppAppIndexLazyRoute;
  '/_layout-app/app/chats/$chatId': typeof LayoutAppAppChatsChatIdRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/auth'
    | '/sign-out'
    | '/about'
    | '/contact'
    | '/features'
    | '/privacy'
    | '/roadmap'
    | '/terms'
    | '/welcome'
    | '/'
    | '/app/chats'
    | '/app/brand-guide'
    | '/app/receipts'
    | '/app/settings'
    | '/app/support'
    | '/app/transactions'
    | '/app'
    | '/app/chats/$chatId';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/auth'
    | '/sign-out'
    | '/about'
    | '/contact'
    | '/features'
    | '/privacy'
    | '/roadmap'
    | '/terms'
    | '/welcome'
    | '/'
    | '/app/chats'
    | '/app/brand-guide'
    | '/app/receipts'
    | '/app/settings'
    | '/app/support'
    | '/app/transactions'
    | '/app'
    | '/app/chats/$chatId';
  id:
    | '__root__'
    | '/_layout'
    | '/_layout-app'
    | '/auth'
    | '/sign-out'
    | '/_layout/about'
    | '/_layout/contact'
    | '/_layout/features'
    | '/_layout/privacy'
    | '/_layout/roadmap'
    | '/_layout/terms'
    | '/_layout/welcome'
    | '/_layout/'
    | '/_layout-app/app/chats'
    | '/_layout-app/app/brand-guide'
    | '/_layout-app/app/receipts'
    | '/_layout-app/app/settings'
    | '/_layout-app/app/support'
    | '/_layout-app/app/transactions'
    | '/_layout-app/app/'
    | '/_layout-app/app/chats/$chatId';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  LayoutLazyRoute: typeof LayoutLazyRouteWithChildren;
  LayoutAppLazyRoute: typeof LayoutAppLazyRouteWithChildren;
  AuthLazyRoute: typeof AuthLazyRoute;
  SignOutLazyRoute: typeof SignOutLazyRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-out': {
      id: '/sign-out';
      path: '/sign-out';
      fullPath: '/sign-out';
      preLoaderRoute: typeof SignOutLazyRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/auth': {
      id: '/auth';
      path: '/auth';
      fullPath: '/auth';
      preLoaderRoute: typeof AuthLazyRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_layout-app': {
      id: '/_layout-app';
      path: '';
      fullPath: '';
      preLoaderRoute: typeof LayoutAppLazyRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_layout': {
      id: '/_layout';
      path: '';
      fullPath: '';
      preLoaderRoute: typeof LayoutLazyRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_layout/': {
      id: '/_layout/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof LayoutIndexLazyRouteImport;
      parentRoute: typeof LayoutLazyRoute;
    };
    '/_layout/welcome': {
      id: '/_layout/welcome';
      path: '/welcome';
      fullPath: '/welcome';
      preLoaderRoute: typeof LayoutWelcomeLazyRouteImport;
      parentRoute: typeof LayoutLazyRoute;
    };
    '/_layout/terms': {
      id: '/_layout/terms';
      path: '/terms';
      fullPath: '/terms';
      preLoaderRoute: typeof LayoutTermsLazyRouteImport;
      parentRoute: typeof LayoutLazyRoute;
    };
    '/_layout/roadmap': {
      id: '/_layout/roadmap';
      path: '/roadmap';
      fullPath: '/roadmap';
      preLoaderRoute: typeof LayoutRoadmapLazyRouteImport;
      parentRoute: typeof LayoutLazyRoute;
    };
    '/_layout/privacy': {
      id: '/_layout/privacy';
      path: '/privacy';
      fullPath: '/privacy';
      preLoaderRoute: typeof LayoutPrivacyLazyRouteImport;
      parentRoute: typeof LayoutLazyRoute;
    };
    '/_layout/features': {
      id: '/_layout/features';
      path: '/features';
      fullPath: '/features';
      preLoaderRoute: typeof LayoutFeaturesLazyRouteImport;
      parentRoute: typeof LayoutLazyRoute;
    };
    '/_layout/contact': {
      id: '/_layout/contact';
      path: '/contact';
      fullPath: '/contact';
      preLoaderRoute: typeof LayoutContactLazyRouteImport;
      parentRoute: typeof LayoutLazyRoute;
    };
    '/_layout/about': {
      id: '/_layout/about';
      path: '/about';
      fullPath: '/about';
      preLoaderRoute: typeof LayoutAboutLazyRouteImport;
      parentRoute: typeof LayoutLazyRoute;
    };
    '/_layout-app/app/': {
      id: '/_layout-app/app/';
      path: '/app';
      fullPath: '/app';
      preLoaderRoute: typeof LayoutAppAppIndexLazyRouteImport;
      parentRoute: typeof LayoutAppLazyRoute;
    };
    '/_layout-app/app/transactions': {
      id: '/_layout-app/app/transactions';
      path: '/app/transactions';
      fullPath: '/app/transactions';
      preLoaderRoute: typeof LayoutAppAppTransactionsLazyRouteImport;
      parentRoute: typeof LayoutAppLazyRoute;
    };
    '/_layout-app/app/support': {
      id: '/_layout-app/app/support';
      path: '/app/support';
      fullPath: '/app/support';
      preLoaderRoute: typeof LayoutAppAppSupportLazyRouteImport;
      parentRoute: typeof LayoutAppLazyRoute;
    };
    '/_layout-app/app/settings': {
      id: '/_layout-app/app/settings';
      path: '/app/settings';
      fullPath: '/app/settings';
      preLoaderRoute: typeof LayoutAppAppSettingsLazyRouteImport;
      parentRoute: typeof LayoutAppLazyRoute;
    };
    '/_layout-app/app/receipts': {
      id: '/_layout-app/app/receipts';
      path: '/app/receipts';
      fullPath: '/app/receipts';
      preLoaderRoute: typeof LayoutAppAppReceiptsLazyRouteImport;
      parentRoute: typeof LayoutAppLazyRoute;
    };
    '/_layout-app/app/brand-guide': {
      id: '/_layout-app/app/brand-guide';
      path: '/app/brand-guide';
      fullPath: '/app/brand-guide';
      preLoaderRoute: typeof LayoutAppAppBrandGuideLazyRouteImport;
      parentRoute: typeof LayoutAppLazyRoute;
    };
    '/_layout-app/app/chats': {
      id: '/_layout-app/app/chats';
      path: '/app/chats';
      fullPath: '/app/chats';
      preLoaderRoute: typeof LayoutAppAppChatsRouteImport;
      parentRoute: typeof LayoutAppLazyRoute;
    };
    '/_layout-app/app/chats/$chatId': {
      id: '/_layout-app/app/chats/$chatId';
      path: '/$chatId';
      fullPath: '/app/chats/$chatId';
      preLoaderRoute: typeof LayoutAppAppChatsChatIdRouteImport;
      parentRoute: typeof LayoutAppAppChatsRoute;
    };
  }
}

interface LayoutLazyRouteChildren {
  LayoutAboutLazyRoute: typeof LayoutAboutLazyRoute;
  LayoutContactLazyRoute: typeof LayoutContactLazyRoute;
  LayoutFeaturesLazyRoute: typeof LayoutFeaturesLazyRoute;
  LayoutPrivacyLazyRoute: typeof LayoutPrivacyLazyRoute;
  LayoutRoadmapLazyRoute: typeof LayoutRoadmapLazyRoute;
  LayoutTermsLazyRoute: typeof LayoutTermsLazyRoute;
  LayoutWelcomeLazyRoute: typeof LayoutWelcomeLazyRoute;
  LayoutIndexLazyRoute: typeof LayoutIndexLazyRoute;
}

const LayoutLazyRouteChildren: LayoutLazyRouteChildren = {
  LayoutAboutLazyRoute: LayoutAboutLazyRoute,
  LayoutContactLazyRoute: LayoutContactLazyRoute,
  LayoutFeaturesLazyRoute: LayoutFeaturesLazyRoute,
  LayoutPrivacyLazyRoute: LayoutPrivacyLazyRoute,
  LayoutRoadmapLazyRoute: LayoutRoadmapLazyRoute,
  LayoutTermsLazyRoute: LayoutTermsLazyRoute,
  LayoutWelcomeLazyRoute: LayoutWelcomeLazyRoute,
  LayoutIndexLazyRoute: LayoutIndexLazyRoute,
};

const LayoutLazyRouteWithChildren = LayoutLazyRoute._addFileChildren(
  LayoutLazyRouteChildren,
);

interface LayoutAppAppChatsRouteChildren {
  LayoutAppAppChatsChatIdRoute: typeof LayoutAppAppChatsChatIdRoute;
}

const LayoutAppAppChatsRouteChildren: LayoutAppAppChatsRouteChildren = {
  LayoutAppAppChatsChatIdRoute: LayoutAppAppChatsChatIdRoute,
};

const LayoutAppAppChatsRouteWithChildren =
  LayoutAppAppChatsRoute._addFileChildren(LayoutAppAppChatsRouteChildren);

interface LayoutAppLazyRouteChildren {
  LayoutAppAppChatsRoute: typeof LayoutAppAppChatsRouteWithChildren;
  LayoutAppAppBrandGuideLazyRoute: typeof LayoutAppAppBrandGuideLazyRoute;
  LayoutAppAppReceiptsLazyRoute: typeof LayoutAppAppReceiptsLazyRoute;
  LayoutAppAppSettingsLazyRoute: typeof LayoutAppAppSettingsLazyRoute;
  LayoutAppAppSupportLazyRoute: typeof LayoutAppAppSupportLazyRoute;
  LayoutAppAppTransactionsLazyRoute: typeof LayoutAppAppTransactionsLazyRoute;
  LayoutAppAppIndexLazyRoute: typeof LayoutAppAppIndexLazyRoute;
}

const LayoutAppLazyRouteChildren: LayoutAppLazyRouteChildren = {
  LayoutAppAppChatsRoute: LayoutAppAppChatsRouteWithChildren,
  LayoutAppAppBrandGuideLazyRoute: LayoutAppAppBrandGuideLazyRoute,
  LayoutAppAppReceiptsLazyRoute: LayoutAppAppReceiptsLazyRoute,
  LayoutAppAppSettingsLazyRoute: LayoutAppAppSettingsLazyRoute,
  LayoutAppAppSupportLazyRoute: LayoutAppAppSupportLazyRoute,
  LayoutAppAppTransactionsLazyRoute: LayoutAppAppTransactionsLazyRoute,
  LayoutAppAppIndexLazyRoute: LayoutAppAppIndexLazyRoute,
};

const LayoutAppLazyRouteWithChildren = LayoutAppLazyRoute._addFileChildren(
  LayoutAppLazyRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  LayoutLazyRoute: LayoutLazyRouteWithChildren,
  LayoutAppLazyRoute: LayoutAppLazyRouteWithChildren,
  AuthLazyRoute: AuthLazyRoute,
  SignOutLazyRoute: SignOutLazyRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
